export default __webpack_public_path__ + "static/media/statistics.56e706da.svg";